
    import {Component, Vue, Watch} from 'vue-property-decorator';
    import {deptApi} from "@/api/organization";
    import CoordPicker from "@/components/CoordPicker.vue";

    @Component({
        name: 'Sys_Dept',
        components: {CoordPicker}
    })
    export default class Home extends Vue {
        loading = false
        deptList = [] // 部分列表
        deptSaving = false
        deptDialog = {
            visible: false,
            deptItem: null as any,
        }
        position = null as any //坐标点
        // 验证邮箱的规则
        prefixValidator = (rule: any, value: any, cb: any) => {
            const regExp =  /^[a-zA-Z]{1,4}$/
            if(regExp.test(value)) {
                cb();
            } else {
                cb(new Error('最多4个英文字符'));
            }
        }
        formRules = {
            name: [{required: true, message: '请输入部门名称', trigger: 'blur'}],
            // prefix: [
            //     {required: true, message: '请输入部门简称', trigger: 'blur'},
            //     {validator: this.prefixValidator,trigger:'blur'}
            // ],
            // addressLocation: [{required: true, message: '请选择地理位置', trigger: 'blur'}],
            // address: [{required: true, message: '请输入部门地址', trigger: 'blur'}],
            userName: [{required: true, message: '请输入联系人名称', trigger: 'blur'}],
            userMobile: [{required: true, message: '请输入联系人电话', trigger: 'blur'}],
            // orderIndex: [{required: true, message: '请输入菜单名称', trigger: 'blur'}],
        }
        map = {
            visible: false,
        }
        created() {
            this.getItemTree();
        }

        getItemTree() {
            deptApi.tree(null).then((r) => {
                if (r.data.result === 0) {
                    const deptList = r.data.data;
                    this.addItemNumber(deptList);
                    this.deptList = deptList;
                    this.$nextTick(()=>{
                        let $table = this.$refs.table as HTMLFormElement;
                        if($table){
                            $table.doLayout();
                        }
                    })
                }
            });
        }

        showMap() {
            if(this.deptDialog.deptItem != null && this.deptDialog.deptItem.addressLocation){
                const addressLocation = this.deptDialog.deptItem.addressLocation.split(",");
                this.position = {lng : addressLocation[0], lat: addressLocation[1]};
            }
            this.map.visible = true;
        }

        //地图选点
        changeMap(e: any) {
            this.map.visible = false;
            this.deptDialog.deptItem.addressLocation = e.position.join(",");
            this.deptDialog.deptItem.address = e.address;
        }

        cloneObjectFn(obj: any) {
            return JSON.parse(JSON.stringify(obj));
        }

        addDept(){
            let form = this.$refs.form as HTMLFormElement;
            form.validate((valid: any) => {
                if (valid) {
                    this.deptSaving = true;
                    const deptItem = this.cloneObjectFn(this.deptDialog.deptItem);
                    if(deptItem.prefix){
                      deptItem.prefix = deptItem.prefix.toUpperCase();
                    }
                    if (deptItem.id) {
                        deptApi.update(deptItem).then(data => {
                            if (data.data.result === 0) {
                                this.$message.success("编辑成功")
                                this.closeDeptDialog()
                                this.getItemTree()
                            }
                        })
                    } else {
                        deptApi.add(deptItem).then(data => {
                            if (data.data.result === 0) {
                                this.$message.success("添加成功")
                                this.closeDeptDialog()
                                this.getItemTree()
                            }
                        });
                    }

                }
            })
        }

        addItemNumber(deptList: any) {
            let num = 0;
            deptList.forEach((dept: any) => {
                dept.upDisable = true;
                dept.downDisable = true;
                if (num != 0) {
                    dept.upOrderId = deptList[num - 1].id;
                    dept.upDisable = false;
                }
                if (num != (deptList.length - 1)) {
                    dept.downOrderId = deptList[num + 1].id;
                    dept.downDisable = false;
                }
                num++;
                if (dept.children && dept.children.length > 0) {
                    this.addItemNumber(dept.children);
                }
            });
        }

        isDisabledMove(row: any, moveType: string) {
            if (moveType === 'up') {
                return row.upDisable;
            } else if (moveType === 'down') {
                return row.downDisable;
            }
        }

        editIndexItemBtn(item: any) {
            this.deptDialog.visible = true;
            this.deptDialog.deptItem = this.cloneObjectFn(item);
        }

        moveIndexItem(row: any, moveType: string) {
            const id = row.id;
            let orderId = 0;
            if (moveType === 'up') {
                orderId = row.upOrderId;
            } else if (moveType === 'down') {
                orderId = row.downOrderId;
            }
            deptApi.move(id, orderId).then((data) => {
                if (data.data.result === 0) {
                    this.$message.success("移动成功")
                    this.getItemTree();
                }
            });
        }

        addDeptBtn(item: any) {
            this.deptDialog.visible = true;
            this.deptDialog.deptItem = this.resetDeptFrom();
            this.deptDialog.deptItem.parentId = item.id;
        }
        closeDeptDialog() {
            this.deptSaving = false;
            this.position = null;
            this.deptDialog = {visible: false, deptItem: null};
        }
        resetDeptFrom() {
            return {
                id: 0,
                ownerId: '',
                parentId: '', //权限名称
                name: '',
                // prefix: '', //部门简称
                addressLocation: '',
                address: '',
                userName: '',
                userMobile: '',
                orderIndex: 0,
            }
        }
        deleteIndexItem(row: any) {
            this.$confirm('确定要删除？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                deptApi.delete(row.id).then((data) => {
                    if (data.data.result === 0) {
                        this.$message.success("删除成功");
                        this.getItemTree();
                    }
                });
            }).catch(() => {
                console.log("取消")
            });
        }
    }
